import { createReducer, on } from '@ngrx/store';
import { LoadingInfo } from '@scip/api';
import * as SubmissionsPageActions from './submissions-page.actions';

export const configureSortField = (tableState: LoadingInfo): LoadingInfo => {
  // This is needed as there is no property product.name on backend side for dossiers --> product.resource.name
  if (tableState?.sortField === 'product.name') {
    return {
      ...tableState,
      sortField: 'product.resource.name'
    };
  }
  return { ...tableState };
};

export interface State {
  tableState: LoadingInfo;
  userSettings: Record<string, any>;
  error: Error;
}

export const SUBMISSIONS_PAGE_FEATURE_KEY = 'submissionsPage';

export const initialState: State = {
  tableState: {
    first: 0,
    rows: 50
  },
  userSettings: null,
  error: null
};

export const submissionsPageReducer = createReducer(
  initialState,
  on(SubmissionsPageActions.clear, () => ({
    ...initialState
  })),
  on(SubmissionsPageActions.setTableState, (state, { tableState }) => ({
    ...state,
    tableState: {
      ...tableState,
      sortField: configureSortField(tableState).sortField
    }
  })),
  on(SubmissionsPageActions.setLatestSearchId, (state, { searchId }) => ({
    ...state,
    tableState: {
      ...state.tableState,
      searchId
    }
  })),
  on(SubmissionsPageActions.setUserSettingsSuccess, (state, { settings }) => ({
    ...state,
    tableState: {
      ...state.tableState,
      sortField: configureSortField(settings)?.sortField,
      first: 0,
      rows: settings?.rows ? settings.rows : 50,
      filters: {...settings?.filters},
      searchId: state.tableState?.searchId
    },
    userSettings: {
      ...configureSortField(settings),
      filters: {...settings?.filters}
    }
  })),
  on(SubmissionsPageActions.setUserSettingsFail, (state, { error }) => ({
    ...state,
    error: error
  })),
  on(SubmissionsPageActions.getUserSettingsSuccess, (state, { settings }) => ({
    ...state,
    tableState: {
      sortField: configureSortField(settings)?.sortField,
      first: 0,
      rows: settings?.rows ? settings.rows : 50,
      filters: {...settings?.filters},
      searchId: state.tableState?.searchId
    },
    userSettings: {
      ...configureSortField(settings),
      filters: {...settings?.filters}
    }
  })),
  on(SubmissionsPageActions.getUserSettingsFail, (state, { error }) => ({
    ...state,
    error
  })),
  on(SubmissionsPageActions.resetFilters, (state) => ({
    ...state,
    tableState: {
      ...state.tableState,
      filters: {}
    },
    userSettings: {
      ...state.userSettings,
      filters: {}
    }
  }))
);
